

    import { ref } from 'vue'
    import axios from "axios";
    import {useToast} from "primevue/usetoast";
    import {useConfirm} from "primevue/useconfirm";
    import router from "@/router";
    import {useStore} from "vuex";
    import {DeTaiForm} from "@/models/deTaiForm.models";
    import NghienCuuKhoaHocRepository from "@/services/NghienCuuKhoaHocRepository";
    import {DeTaiCreate} from "@/models/deTaiCreate";
    import {FileDetail} from "@/models/fileDetail.model";
    import {DeTai} from "@/models/deTai";
    import {Link} from "@/models/link";
    import {NhanXetCreate} from "@/models/nhanXetCreate";
    import {NhanXetDetail} from "@/models/nhanXetDetail";

    export default {
      props: {
        id: Number,
      },
      setup(props){

            const downLoad = ref(false);
            const loadingBar = ref(false);
            const toast = useToast();
            const store = useStore();
            const deTaiCreate = ref({} as DeTaiCreate);
            let listFileName = ref([] as FileDetail[]);
            let listFile = ref([] as FileDetail[]);
            const listLink = ref([] as string[]);
            const deTai = ref({} as DeTai);
            const nhanXet = ref([] as NhanXetDetail[]);

          NghienCuuKhoaHocRepository.deTaiById(props.id)
              .then((response) => {
                deTai.value = response.data;
                if((deTai.value.tapTin == null)||(deTai.value.tapTin == ""))
                {
                }
                else {
                  var str = deTai.value.tapTin.split(">>>>");
                  str.forEach(x => {
                    if(x.length > 0)
                    {
                      var filetemp = ref({} as FileDetail);
                      filetemp.value.nameFile = x.split("/")[2];
                      filetemp.value.value = x;
                      listFile.value.push(filetemp.value);
                    }
                  })
                }
              })
              .catch(error => {
              })
              .finally(
                  //function(){
                  //setTimeout(loadList, 1 * 1000);}
              );

        NghienCuuKhoaHocRepository.listNhanXetById(props.id)
            .then((response) => {
              nhanXet.value = response.data;
            })
            .catch(error => {
            })
            .finally(
                //function(){
                //setTimeout(loadList, 1 * 1000);}
            );


            const confirm = useConfirm();
            const confirmSuccess = () => {
                confirm.require({
                    message: 'Gởi lại đề tài thành công',
                    header: 'Xác nhận',
                    icon: 'pi pi-check-circle',
                    acceptLabel: 'Hoàn thành',
                    //rejectLabel: 'Gởi tiếp',
                    accept: () => {
                        //reset();
                    },
                    reject: () => {
                    }
                });
            };

        const goiLaiDeTai = () => {
            console.log("################# goiLaiDeTai");
          // deTai.value.duyetLan1 = "từ chối";
          listLink.value = [];
          var files = new FormData();
          listFileName.value.forEach(x =>
          {
            files.append("formFiles", x.value, x.nameFile);
          });
          loadingBar.value = true;
          axios.post(`/api/file/Upload`, files,
              {
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'multipart/form-data'
                }
              }).then(response => {
            const list = ref([] as string[]);
            list.value = response.data.result;
            //deTaiCreate.value.tapTin = "";
            list.value.forEach(x => {
              deTai.value.tapTin += x + ">>>>";
            })
            deTai.value.duyetLan1 = "";
            deTai.value.duyetLan2 = "";
            deTai.value.duyetLan2 = "";
          NghienCuuKhoaHocRepository.updateDeTai(deTai.value)
              .then((response) => {
                loadingBar.value = false;
                confirmSuccess();
              })
              .catch(error => {
                loadingBar.value = false;
              })
              .finally(
                  //function(){
                  //setTimeout(loadList, 1 * 1000);}
              ); })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })});
        }
        const downLoadFile = (file) => {
          const links = ref({} as Link);
          links.value.linkFile = file;
          axios({
            url: '../api/nghiencuu/download/',
            method: 'GET',
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/json'
            },
            params: { linkFile: links.value.linkFile },
          })
              .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', links.value.linkFile.split("/")[2]);
            document.body.appendChild(link);
            link.click();


          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
        };
        const fileChange = (fileList) => {
          console.log("###### fileChange");
          var leng = fileList.length;
          for (var i = 0; i < leng; i++)
          {
            var filetemp = ref({} as FileDetail);
            filetemp.value.nameFile = fileList[i].name;
            filetemp.value.value = fileList[i];
            listFileName.value.push(filetemp.value);
          }
          console.log("###### fileChange fileList: " + JSON.stringify(fileList.value));
          console.log("###### fileChange listFileName: " + JSON.stringify(listFileName.value));
        };
        const deleteFile = (name: string) =>
        {
          listFileName.value.findIndex(x => x.nameFile == name);
          listFileName.value.splice(listFileName.value.findIndex(x => x.nameFile == name), 1);
        };

            return {
                downLoad,
                loadingBar,
                deTaiCreate,
                listFileName,
              deTai,
              downLoadFile,
              nhanXet,
              goiLaiDeTai,
              listFile,
              fileChange,
              deleteFile,
            }
        }
    }

